var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wac-layout',[_c('wac-spacing',[_c('div',{attrs:{"id":"ot-sdk-cookie-policy"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }